import { createIcon } from "@chakra-ui/react";

export const Pass = createIcon({
  displayName: "Pass",
  viewBox: "0 0 24 24",
  d: "M20.125 12a8.125 8.125 0 1 1-16.25 0 8.125 8.125 0 0 1 16.25 0zM2 12a10 10 0 1 0 20 0 10 10 0 0 0-20 0zm13.063 2.426A4.116 4.116 0 0 1 12 15.75a4.116 4.116 0 0 1-3.063-1.324.938.938 0 0 0-1.378 1.27c.859.929 2.343 1.929 4.437 1.929a5.96 5.96 0 0 0 4.438-1.93.934.934 0 0 0-.055-1.324.934.934 0 0 0-1.324.055h.008zm-1.204-4.301a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0zm-5 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z",
  defaultProps: {
    "aria-label": "Smiling face"
  }
});

export default Pass;
